<template>
  <div class="how-to">
    <h1 class="text-shadow-thin-white">{{ $t("eisenach.howToPlay") }}</h1>
    <p>{{ $t("eisenach.howP1") }}</p>
    <p>
      <span class="highlight text-shadow-extra-thin-white">
        {{ $t("eisenach.howP2") }}
      </span>
    </p>
    <p>{{ $t("eisenach.howP3") }}</p>
  </div>
</template>
<script>
export default {
  name: "EisenachHowTo",
};
</script>
